(function () {
      const dataEl = document.getElementById('faq-data');
      if (!dataEl) return;

      const faqData    = JSON.parse(dataEl.textContent);
      const categories = faqData.categories || [];
      const faqs       = faqData.faqs || [];
      const MAX_DEFAULT_FAQS = 4;
      const assemblies = faqData.assemblies || [];
      const amazons = faqData.amazons || [];
      const showFeedback = faqData.show_feedback !== false;
      const ASSEMBLY_CATEGORY_ID = 'assembly';

      // Quick lookup by FAQ id
      const faqById = {};
      faqs.forEach(function (faq) {
        faqById[String(faq.id)] = faq;
      });

      const searchInput          = document.getElementById('faq-search-input');
      const accordionList        = document.getElementById('faq-accordion-list');
      const resultsCount         = document.getElementById('faq-results-count');
      const noResultsEl          = document.getElementById('faq-no-results');
      const expandToggle         = document.getElementById('faq-expand-toggle');
      const faqBody              = document.getElementById('faq-body');
      const categoryCards        = document.querySelectorAll('.faq-category-card');
      const categoryGridWrapper  = document.getElementById('faq-category-grid-wrapper');
      const filterPillsContainer = document.getElementById('faq-filter-pills');
      const filterPills = filterPillsContainer
        ? filterPillsContainer.querySelectorAll('.faq-filter-pill')
        : [];
      const breadcrumb        = document.getElementById('faq-breadcrumb');
      const breadcrumbCurrent = document.getElementById('faq-breadcrumb-current');
      const resultsSidebar    = document.getElementById('faq-results-sidebar');
      const backButton        = document.getElementById('faq-back-button');
      const seeAllBtn         = document.getElementById('faq-see-all');

      let showAllFaqs            = false;
      let expandedAll            = false;
      let currentCategoryId      = null;  // category selected from cards
      let activeSearchCategoryId = null;  // search filter pill
      let selectedAssemblySource = 'zinus';

      // Deep-link modes
      let deepLinkFaq          = null; // FAQ object when linked via ?a=
      let deepLinkCategoryMode = false; // true when landing via ?g=

      /* ------------------ helpers ------------------ */

      function normalizeFaqKey(val) {
        if (!val) return '';
        let s = String(val).trim();
        s = s.replace(/^https?:\/\/[^?]+/i, '');
        s = s.replace(/^\/?pages\/support\?a=/i, '');
        s = s.replace(/^pages\/support\?a=/i, '');
        return s.trim();
      }

      function normalizeCategoryKey(val) {
        if (!val) return '';
        let s = String(val).trim();
        s = s.replace(/^https?:\/\/[^?]+/i, '');
        s = s.replace(/^\/?pages\/support\?g=/i, '');
        s = s.replace(/^pages\/support\?g=/i, '');
        return s.trim().toLowerCase();
      }

      function setCategoryUrlParam(gValue) {
        if (!gValue || !window.history || !window.history.replaceState) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('g', gValue);
          url.searchParams.delete('a');
          url.searchParams.delete('faq');
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          console.warn('Unable to update category URL', e);
        }
      }

      function clearCategoryUrlParam() {
        if (!window.history || !window.history.replaceState) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('g');
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          console.warn('Unable to clear category URL', e);
        }
      }

      function setFaqUrlParam(aValue) {
        if (!aValue || !window.history || !window.history.replaceState) return;
        try {
          const cleanA = normalizeFaqKey(aValue);
          const url = new URL(window.location.href);
          url.searchParams.set('a', cleanA);
          url.searchParams.delete('g');
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          console.warn('Unable to update FAQ URL', e);
        }
      }

      function clearFaqUrlParam() {
        if (!window.history || !window.history.replaceState) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('a');
          url.searchParams.delete('faq');
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          console.warn('Unable to clear FAQ URL', e);
        }
      }

      function getCategoryNameById(id) {
        const match = categories.find(c => String(c.id) === String(id));
        return match ? match.name : 'All Categories';
      }

      function normalize(str) {
        return (str || '').toString().toLowerCase();
      }

      function safeTags(rawTags) {
        if (!rawTags) return [];
        if (Array.isArray(rawTags)) return rawTags;
        if (typeof rawTags === 'string') return [rawTags];
        if (typeof rawTags === 'object' && Array.isArray(rawTags.value)) {
          return rawTags.value;
        }
        return [];
      }

      function setFilterPillState(filterId) {
        if (!filterPillsContainer) return;
        activeSearchCategoryId = (filterId === 'all') ? null : filterId;
        filterPills.forEach(function (pill) {
          const id = pill.getAttribute('data-filter');
          const isActive = id === filterId;
          pill.classList.toggle('is-active', isActive);
          pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function matchesQuery(faq, q) {
        if (!q) return true;
        const nQ       = normalize(q);
        const question = normalize(faq.question);
        const answer   = normalize(faq.answer_html);
        const tagsText = safeTags(faq.tags).map(normalize).join(' ');
        return (
          question.indexOf(nQ) !== -1 ||
          answer.indexOf(nQ)   !== -1 ||
          tagsText.indexOf(nQ) !== -1
        );
      }

      function highlight(text, q) {
        if (!q) return text;
        const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const pattern = new RegExp('(' + escaped + ')', 'ig');
        return text.replace(pattern, '<mark>$1</mark>');
      }

      // Liquid cannot run inside assets/*.js — feedback visibility comes from faq-data JSON.
      function renderFeedbackBlock(faqId) {
        if (!showFeedback) return '';
        return `
          <div class="faq-feedback" data-faq-id="${faqId}">
            <span>Did this answer your question?</span>
            <button type="button" class="faq-feedback-yes">Yes</button>
            <button type="button" class="faq-feedback-no">No</button>
          </div>
        `;
      }

      function renderAssemblyToggleBlock() {
        const isAmazon = selectedAssemblySource === 'amazon';

        return `
          <div class="faq-assembly-toggle">
            <h2 class="faq-assembly-heading">Assembly Instructions</h2>
            <p class="faq-assembly-subtext">
              Select where you purchased your bed frame to find the right assembly guide.
            </p>

            <div class="faq-assembly-toggle-buttons" role="tablist" aria-label="Assembly source">
              <button
                id="tab-zinus"
                role="tab"
                aria-selected="${!isAmazon}"
                aria-controls="panel-zinus"
                tabindex="${!isAmazon ? '0' : '-1'}"
                class="faq-assembly-source ${!isAmazon ? 'is-active' : ''}"
                data-source="zinus"
              >
                Zinus.com
              </button>

              <button
                id="tab-amazon"
                role="tab"
                aria-selected="${isAmazon}"
                aria-controls="panel-amazon"
                tabindex="${isAmazon ? '0' : '-1'}"
                class="faq-assembly-source ${isAmazon ? 'is-active' : ''}"
                data-source="amazon"
              >
                Amazon
              </button>
            </div>

            <div
              id="panel-zinus"
              role="tabpanel"
              aria-labelledby="tab-zinus"
              ${isAmazon ? 'hidden' : ''}
            ></div>

            <div
              id="panel-amazon"
              role="tabpanel"
              aria-labelledby="tab-amazon"
              ${!isAmazon ? 'hidden' : ''}
            ></div>

            <div class="faq-assembly-status">
              ${isAmazon
                ? '• Showing guides for Amazon purchases'
                : '• Showing guides for Zinus.com purchases'}
            </div>
          </div>
        `;
      }

      /* ------------------ main render ------------------ */

      function renderFaqs() {
        const hasDeepFaqLink = !!deepLinkFaq;
        const hasDeepCatLink = deepLinkCategoryMode;
        const hasAnyDeepLink = hasDeepFaqLink || hasDeepCatLink;

        // In FAQ deep-link mode, we ignore search for filtering
        const q = hasDeepFaqLink ? '' : searchInput.value.trim();
        const hasQuery = q.length > 0;

        accordionList.innerHTML = '';
        let totalCount = 0;

        // Back button visibility:
        // show whenever we are not in the initial grid-only state
        const inResultsView =
          hasAnyDeepLink ||
          showAllFaqs ||
          hasQuery ||
          !!currentCategoryId;

        if (backButton) {
          backButton.classList.toggle('hidden', !inResultsView);
        }

        // Initial state: no search, no category, no see-all, no deep-link
        if (!hasQuery && !currentCategoryId && !showAllFaqs && !hasAnyDeepLink) {
          faqBody.classList.add('is-empty');
          resultsCount.textContent = '';
          noResultsEl.classList.add('hidden');
          expandToggle.style.display = 'none';
          return;
        } else {
          faqBody.classList.remove('is-empty');
        }

        // ===============================
        // ASSEMBLY CATEGORY VIEW
        if (
          !hasQuery &&
          !hasAnyDeepLink &&
          currentCategoryId === ASSEMBLY_CATEGORY_ID
        ) {
          accordionList.innerHTML = '';

          const list = selectedAssemblySource === 'amazon'
          ? amazons.slice()
          : assemblies.slice();
          totalCount = list.length;

          const block = document.createElement('section');
          block.className = 'faq-category-block';
          block.innerHTML = `
            ${renderAssemblyToggleBlock()}
            <div class="faq-category-items"></div>
          `;
          const items = block.querySelector('.faq-category-items');

          list.forEach(function (a) {
            const qId = 'asm-q-' + a.id;
            const aId = 'asm-a-' + a.id;

            const title = a.product_title || a.instructions_title || 'Assembly Instructions';

            const metaLine = [
              a.assembly_sku ? `SKU: ${a.assembly_sku}` : '',
              a.product_title ? `Product: ${a.product_title}` : ''
            ].filter(Boolean).join(' • ');

            const pdfTitle = a.instructions_title || 'Assembly Guide (PDF)';
            const pdfLink  = a.instructions_link || '';

            const href = pdfLink
              ? (pdfLink + (pdfLink.includes('?') ? '&download=1' : '?download=1'))
              : '';

            const answerHtml = `
              ${metaLine ? `<p class="faq-meta-products">${metaLine}</p>` : ''}

              ${pdfLink ? `
                <ul class="faq-assembly-list">
                  <li class="faq-assembly-item">
                    <a class="faq-assembly-link" href="${href}" download>
                      <span class="faq-assembly-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" width="16" height="16">
                          <path d="M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 12h10v2H7v-2zm0 4h10v2H7v-2zm0-8h6v2H7V8z"></path>
                        </svg>
                      </span>
                      <span class="faq-assembly-title">${pdfTitle}</span>
                    </a>
                  </li>
                </ul>
              ` : ''}
            `;

            const wrapper = document.createElement('article');
            wrapper.className = 'faq-item';
            wrapper.innerHTML = `
              <h3 class="faq-question">
                <button
                  class="faq-toggle"
                  aria-expanded="false"
                  aria-controls="${aId}"
                  id="${qId}"
                >
                  <span class="faq-question-text">${title}</span>
                  <span class="faq-toggle-icon" aria-hidden="true">+</span>
                </button>
              </h3>
              <div
                id="${aId}"
                class="faq-answer is-collapsed"
                role="region"
                aria-labelledby="${qId}"
                aria-hidden="true"
              >
                ${answerHtml}
              </div>
            `;
            items.appendChild(wrapper);
          });

          accordionList.appendChild(block);

          faqBody.classList.remove('is-empty');
          noResultsEl.classList.add('hidden');
          resultsCount.textContent =
            totalCount + (totalCount === 1 ? ' result' : ' results');
          expandToggle.style.display = 'none';

          bindAccordionEvents();
          bindAssemblyToggle();
          return;
        }


        /* ----- SEE ALL mode ----- */
        if (showAllFaqs && !hasQuery && !hasAnyDeepLink) {
          accordionList.innerHTML = '';

          const allFaqsSorted = faqs
            .slice()
            .sort(function (a, b) {
              return (a.sort_order || 0) - (b.sort_order || 0);
            });

          totalCount = allFaqsSorted.length;

          const catBlock = document.createElement('section');
          catBlock.className = 'faq-category-block';
          catBlock.innerHTML = `
            <h2 class="faq-category-title">All FAQs</h2>
            <div class="faq-category-items"></div>
          `;
          const itemsContainer = catBlock.querySelector('.faq-category-items');

          allFaqsSorted.forEach(function (faq) {
            const isExpanded = false;
            const qId = 'faq-q-' + faq.id;
            const aId = 'faq-a-' + faq.id;

            const wrapper = document.createElement('article');
            wrapper.className = 'faq-item';
            wrapper.innerHTML = `
              <h3 class="faq-question">
                <button
                  class="faq-toggle"
                  aria-expanded="${isExpanded}"
                  aria-controls="${aId}"
                  id="${qId}"
                  data-faq-id="${faq.id}"
                  data-faq-a="${ normalizeFaqKey(faq.search_link || '') }"
                >
                  <span class="faq-question-text">${faq.question}</span>
                  <span class="faq-toggle-icon" aria-hidden="true">
                    ${isExpanded ? '−' : '+'}
                  </span>
                </button>
              </h3>
              <div
                id="${aId}"
                class="faq-answer is-collapsed"
                role="region"
                aria-labelledby="${qId}"
                aria-hidden="true"
              >
                ${faq.answer_html}
                ${renderFeedbackBlock(faq.id)}
              </div>
            `;
            itemsContainer.appendChild(wrapper);
          });

          accordionList.appendChild(catBlock);

          if (totalCount === 0) {
            resultsCount.textContent = '0 results';
            noResultsEl.classList.remove('hidden');
          } else {
            noResultsEl.classList.add('hidden');
            resultsCount.textContent =
              totalCount + (totalCount === 1 ? ' result' : ' results');
          }

          expandToggle.style.display = 'none';
          bindAccordionEvents();
          return;
        }

        /* ----- CATEGORY / SEARCH / DEEP-LINK rendering ----- */

        categories.forEach(function (cat) {
          const catIdStr = String(cat.id);

          // If we're in FAQ deep-link mode, only render the category
          // that actually contains that FAQ.
          if (hasDeepFaqLink) {
            const deepCatIds = (deepLinkFaq.category_ids || []).map(String);
            if (deepCatIds.length && !deepCatIds.includes(catIdStr)) {
              return;
            }
          }

          // CATEGORY view (no search, no deep-link) → only selected category
          if (!hasQuery && !hasAnyDeepLink && currentCategoryId &&
              catIdStr !== String(currentCategoryId)) {
            return;
          }

          // SEARCH view with active pill filter
          if (hasQuery && activeSearchCategoryId &&
              catIdStr !== activeSearchCategoryId) {
            return;
          }

          // CATEGORY deep-link (?g=) – behaves like category view
          if (!hasQuery && hasDeepCatLink && currentCategoryId &&
              catIdStr !== String(currentCategoryId)) {
            return;
          }

          let catFaqs;

          // FAQ deep link: this category should only show the single FAQ
          if (hasDeepFaqLink) {
            catFaqs = [deepLinkFaq];
          } else if (Array.isArray(cat.faq_ids) && cat.faq_ids.length) {
            // per-category explicit ordering
            const orderedIds = cat.faq_ids.map(String);
            catFaqs = orderedIds
              .map(function (id) { return faqById[id]; })
              .filter(function (faq) { return faq && matchesQuery(faq, q); });
          } else {
            // fallback: membership via category_ids on FAQ
            catFaqs = faqs.filter(function (faq) {
              const ids = (faq.category_ids || []).map(String);
              const inCat = ids.includes(catIdStr);
              return inCat && matchesQuery(faq, q);
            });
          }

          if (!catFaqs.length) return;

          totalCount += catFaqs.length;

          // Default: only first 4 items visible for category view
          let faqsToRender = catFaqs;
          if (!hasQuery && !hasAnyDeepLink && !expandedAll &&
              catFaqs.length > MAX_DEFAULT_FAQS) {
            faqsToRender = catFaqs.slice(0, MAX_DEFAULT_FAQS);
          }

          const catBlock = document.createElement('section');
          catBlock.className = 'faq-category-block';
          catBlock.innerHTML = `
            <h2 class="faq-category-title">${cat.name}</h2>
            <div class="faq-category-items"></div>
          `;
          const itemsContainer = catBlock.querySelector('.faq-category-items');

          faqsToRender.forEach(function (faq) {
            const isDeep     = hasDeepFaqLink && String(faq.id) === String(deepLinkFaq.id);
            const isExpanded = isDeep;
            const qId        = 'faq-q-' + faq.id;
            const aId        = 'faq-a-' + faq.id;
            const searchTerm = hasDeepFaqLink ? '' : q;

            const questionHtml = searchTerm
              ? highlight(faq.question, searchTerm)
              : faq.question;

            const answerHtml = searchTerm
              ? highlight(faq.answer_html, searchTerm)
              : faq.answer_html;

            const wrapper = document.createElement('article');
            wrapper.className = 'faq-item';
            wrapper.innerHTML = `
              <h3 class="faq-question">
                <button
                  class="faq-toggle"
                  aria-expanded="${isExpanded}"
                  aria-controls="${aId}"
                  id="${qId}"
                  data-faq-id="${faq.id}"
                  data-faq-a="${ normalizeFaqKey(faq.search_link || '') }"
                >
                  <span class="faq-question-text">${questionHtml}</span>
                  <span class="faq-toggle-icon" aria-hidden="true">
                    ${isExpanded ? '−' : '+'}
                  </span>
                </button>
              </h3>
              <div
                id="${aId}"
                class="faq-answer ${isExpanded ? '' : 'is-collapsed'}"
                role="region"
                aria-labelledby="${qId}"
                aria-hidden="${isExpanded ? 'false' : 'true'}"
              >
                ${answerHtml}
                ${renderAssemblyBlock(faq)}
                ${renderFeedbackBlock(faq.id)}
              </div>
            `;
            itemsContainer.appendChild(wrapper);
          });

          accordionList.appendChild(catBlock);
        });

        // --- Assembly Instructions results (search only) ---
        // PLACE THIS BLOCK BEFORE the "zero / non-zero results UI" section
        if (hasQuery && !hasAnyDeepLink) {
          const qN = normalize(q);

          const matchingAssemblies = assemblies.filter(function (a) {
            const title   = normalize(a.instructions_title);
            const sku     = normalize(a.assembly_sku);
            const ptitle  = normalize(a.product_title);
            const link    = normalize(a.instructions_link);

            return (
              title.includes(qN) ||
              sku.includes(qN) ||
              ptitle.includes(qN) ||
              link.includes(qN)
            );
          });

          const matchingAmazons = amazons.filter(function (a) {
            const title   = normalize(a.instructions_title);
            const sku     = normalize(a.assembly_sku);
            const ptitle  = normalize(a.product_title);
            const link    = normalize(a.instructions_link);

            return (
              title.includes(qN) ||
              sku.includes(qN) ||
              ptitle.includes(qN) ||
              link.includes(qN)
            );
          });

          if (matchingAssemblies.length) {
            totalCount += matchingAssemblies.length;

            const block = document.createElement('section');
            block.className = 'faq-category-block';
            block.innerHTML = `
              <h2 class="faq-category-title">Assembly Instructions</h2>
              <div class="faq-category-items"></div>
            `;
            const items = block.querySelector('.faq-category-items');

            matchingAssemblies.forEach(function (a) {
              const qId = 'asm-q-' + a.id;
              const aId = 'asm-a-' + a.id;

              const cardTitleRaw = a.product_title || a.instructions_title || 'Assembly Instructions';
              const questionHtml = highlight(cardTitleRaw, q);

              const metaLine = [
                a.assembly_sku ? `SKU: ${a.assembly_sku}` : '',
                a.product_title ? `Product: ${a.product_title}` : ''
              ].filter(Boolean).join(' • ');

              const pdfTitle = highlight(a.instructions_title || 'Assembly Guide (PDF)', q);
              const pdfLink  = (a.instructions_link || '').trim();
              const href = pdfLink
                ? (pdfLink + (pdfLink.includes('?') ? '&download=1' : '?download=1'))
                : '';

              const answerHtml = `
                ${metaLine ? `<p class="faq-meta-products">${metaLine}</p>` : ''}

                ${href ? `
                  <ul class="faq-assembly-list">
                    <li class="faq-assembly-item">
                      <a class="faq-assembly-link" href="${href}" download>
                        <span class="faq-assembly-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" width="16" height="16">
                            <path d="M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 12h10v2H7v-2zm0 4h10v2H7v-2zm0-8h6v2H7V8z"></path>
                          </svg>
                        </span>
                        <span class="faq-assembly-title">${pdfTitle}</span>
                      </a>
                    </li>
                  </ul>
                ` : ''}
              `;

              const wrapper = document.createElement('article');
              wrapper.className = 'faq-item';
              wrapper.innerHTML = `
                <h3 class="faq-question">
                  <button
                    class="faq-toggle"
                    aria-expanded="false"
                    aria-controls="${aId}"
                    id="${qId}"
                    data-faq-a=""
                  >
                    <span class="faq-question-text">${questionHtml}</span>
                    <span class="faq-toggle-icon" aria-hidden="true">+</span>
                  </button>
                </h3>
                <div
                  id="${aId}"
                  class="faq-answer is-collapsed"
                  role="region"
                  aria-labelledby="${qId}"
                  aria-hidden="true"
                >
                  ${answerHtml}
                </div>
              `;
              items.appendChild(wrapper);
            });

            accordionList.appendChild(block);
          }

          if (matchingAmazons.length) {
            totalCount += matchingAmazons.length;

            const block = document.createElement('section');
            block.className = 'faq-category-block';
            block.innerHTML = `
              <h2 class="faq-category-title">Amazon Instructions</h2>
              <div class="faq-category-items"></div>
            `;
            const items = block.querySelector('.faq-category-items');

            matchingAmazons.forEach(function (a) {
              const qId = 'amz-q-' + a.id;
              const aId = 'amz-a-' + a.id;

              const cardTitleRaw = a.product_title || a.instructions_title || 'Amazon Instructions';
              const questionHtml = highlight(cardTitleRaw, q);

              const metaLine = [
                a.assembly_sku ? `SKU: ${a.assembly_sku}` : '',
                a.product_title ? `Product: ${a.product_title}` : ''
              ].filter(Boolean).join(' • ');

              const pdfTitle = highlight(a.instructions_title || 'Amazon Guide (PDF)', q);
              const pdfLink  = (a.instructions_link || '').trim();
              const href = pdfLink
                ? (pdfLink + (pdfLink.includes('?') ? '&download=1' : '?download=1'))
                : '';

              const answerHtml = `
                ${metaLine ? `<p class="faq-meta-products">${metaLine}</p>` : ''}

                ${href ? `
                  <ul class="faq-assembly-list">
                    <li class="faq-assembly-item">
                      <a class="faq-assembly-link" href="${href}" download>
                        <span class="faq-assembly-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" width="16" height="16">
                            <path d="M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 12h10v2H7v-2zm0 4h10v2H7v-2zm0-8h6v2H7V8z"></path>
                          </svg>
                        </span>
                        <span class="faq-assembly-title">${pdfTitle}</span>
                      </a>
                    </li>
                  </ul>
                ` : ''}
              `;

              const wrapper = document.createElement('article');
              wrapper.className = 'faq-item';
              wrapper.innerHTML = `
                <h3 class="faq-question">
                  <button
                    class="faq-toggle"
                    aria-expanded="false"
                    aria-controls="${aId}"
                    id="${qId}"
                    data-faq-a=""
                  >
                    <span class="faq-question-text">${questionHtml}</span>
                    <span class="faq-toggle-icon" aria-hidden="true">+</span>
                  </button>
                </h3>
                <div
                  id="${aId}"
                  class="faq-answer is-collapsed"
                  role="region"
                  aria-labelledby="${qId}"
                  aria-hidden="true"
                >
                  ${answerHtml}
                </div>
              `;
              items.appendChild(wrapper);
            });

            accordionList.appendChild(block);
          }
        }
        

        /* ----- zero / non-zero results UI ----- */

        if (totalCount === 0) {
          const hasQueryNow = searchInput.value.trim().length > 0;
          resultsCount.textContent = hasQueryNow ? '0 results' : 'No questions found';
          expandToggle.style.display = 'none';

          // suggestions
          const topCategories = categories.slice(0, 3);
          const popularFaqs   = faqs.slice(0, 3);

          let catHtml = '';
          if (topCategories.length) {
            catHtml = `
              <div class="faq-no-results-block">
                <h3 class="faq-no-results-subtitle">Browse top categories</h3>
                <ul class="faq-no-results-list">
                  ${topCategories.map(function (c) {
                    return `
                      <li>
                        <button
                          type="button"
                          class="faq-no-results-category"
                          data-suggest-category-id="${c.id}"
                        >
                          ${c.name}
                        </button>
                      </li>
                    `;
                  }).join('')}
                </ul>
              </div>
            `;
          }

          let faqHtml = '';
          if (popularFaqs.length) {
            faqHtml = `
              <div class="faq-no-results-block">
                <h3 class="faq-no-results-subtitle">Popular FAQs</h3>
                <ul class="faq-no-results-list">
                  ${popularFaqs.map(function (f) {
                    return `
                      <li>
                        <button
                          type="button"
                          class="faq-no-results-faq"
                          data-suggest-faq-id="${f.id}"
                        >
                          ${f.question}
                        </button>
                      </li>
                    `;
                  }).join('')}
                </ul>
              </div>
            `;
          }

          noResultsEl.innerHTML = `
            <p class="faq-no-results-title">No results found.</p>
            <p class="faq-no-results-text">
              Try a different keyword, or jump into one of these:
            </p>
            <div class="faq-no-results-suggestions">
              ${catHtml}
              ${faqHtml}
            </div>
          `;
          noResultsEl.classList.remove('hidden');
          attachNoResultsHandlers();
        } else {
          noResultsEl.classList.add('hidden');

          const qNow        = searchInput.value.trim();
          const hasQueryNow = qNow.length > 0;

          if (hasDeepFaqLink && deepLinkFaq && !hasQueryNow) {
            resultsCount.textContent = `1 result for "${deepLinkFaq.question}"`;
          } else if (hasQueryNow) {
            const catLabel = activeSearchCategoryId
              ? getCategoryNameById(activeSearchCategoryId)
              : 'All Categories';
            const plural = totalCount === 1 ? '' : 's';
            resultsCount.textContent =
              `${totalCount} result${plural} for "${qNow}" in ${catLabel}`;
          } else {
            resultsCount.textContent =
              totalCount + (totalCount === 1 ? ' result' : ' results');
          }

          if (!hasQueryNow && !hasAnyDeepLink && totalCount > MAX_DEFAULT_FAQS) {
            expandToggle.style.display = 'inline-block';
            expandToggle.textContent = expandedAll ? 'Show less' : 'Show all';
          } else {
            expandToggle.style.display = 'none';
          }
        }

        bindAccordionEvents();
      }

      /* ------------------ events ------------------ */

      function bindAccordionEvents() {
        const toggles = accordionList.querySelectorAll('.faq-toggle');
        toggles.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            const item     = btn.closest('.faq-item');
            const answerEl = item ? item.querySelector('.faq-answer') : null;
            if (!answerEl) return;

            const nowExpanded = !expanded;
            btn.setAttribute('aria-expanded', nowExpanded ? 'true' : 'false');
            answerEl.classList.toggle('is-collapsed', !nowExpanded);
            answerEl.setAttribute('aria-hidden', nowExpanded ? 'false' : 'true');
            btn.querySelector('.faq-toggle-icon').textContent = nowExpanded ? '−' : '+';

            const aValue = btn.getAttribute('data-faq-a') || '';
            if (nowExpanded && aValue) {
              setFaqUrlParam(aValue);
            } else if (!nowExpanded) {
              clearFaqUrlParam();
            }

            if (window.dataLayer) {
              window.dataLayer.push({ event: 'faqClick', faqId: btn.id });
            }
          });
        });

        const feedbackButtons = accordionList.querySelectorAll('.faq-feedback button');
        feedbackButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const container = btn.closest('.faq-feedback');
            const faqId = container.getAttribute('data-faq-id');
            const value = btn.classList.contains('faq-feedback-yes') ? 'yes' : 'no';

            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'faqHelpful',
                faqId: faqId,
                helpful: value
              });
            }
            container.innerHTML = '<span>Thanks for your feedback!</span>';
          });
        });
      }

      function bindAssemblyToggle() {
        const tabs = document.querySelectorAll('[role="tab"]');
        if (!tabs.length) return;

        tabs.forEach(function (tab, index) {
          tab.addEventListener('click', activateTab);
          tab.addEventListener('keydown', handleKeydown);
        });

        function activateTab(e) {
          const selectedTab = e.currentTarget;
          const source = selectedTab.getAttribute('data-source');

          // update global state
          selectedAssemblySource = source;

          // update tab states
          tabs.forEach(function (tab) {
            const isSelected = tab === selectedTab;
            tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            tab.setAttribute('tabindex', isSelected ? '0' : '-1');
            tab.classList.toggle('is-active', isSelected);
          });

          // update panels (optional but good for SRs)
          const zinusPanel = document.getElementById('panel-zinus');
          const amazonPanel = document.getElementById('panel-amazon');

          if (zinusPanel && amazonPanel) {
            if (source === 'amazon') {
              zinusPanel.setAttribute('hidden', true);
              amazonPanel.removeAttribute('hidden');
            } else {
              amazonPanel.setAttribute('hidden', true);
              zinusPanel.removeAttribute('hidden');
            }
          }

          renderFaqs(); // re-render content
        }

        function handleKeydown(e) {
          const currentIndex = Array.from(tabs).indexOf(e.currentTarget);
          switch (e.key) {
            case 'ArrowRight':
              e.preventDefault();
              focusTab((currentIndex + 1) % tabs.length);
              break;

            case 'ArrowLeft':
              e.preventDefault();
              focusTab((currentIndex - 1 + tabs.length) % tabs.length);
              break;

            case 'Home':
              e.preventDefault();
              focusTab(0);
              break;

            case 'End':
              e.preventDefault();
              focusTab(tabs.length - 1);
              break;

            case 'Enter':
            case ' ':
              e.preventDefault();
              e.currentTarget.click();
              break;
          }
        }

        function focusTab(index) {
          tabs[index].focus();
        }
      }

      function attachNoResultsHandlers() {
        const catButtons = noResultsEl.querySelectorAll('.faq-no-results-category');
        catButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const catId = btn.getAttribute('data-suggest-category-id');
            if (!catId) return;

            deepLinkFaq          = null;
            deepLinkCategoryMode = false;
            searchInput.value    = '';
            currentCategoryId    = String(catId);
            activeSearchCategoryId = null;

            categoryCards.forEach(function (card) {
              const id = card.getAttribute('data-category-id');
              const isSelected = String(id) === String(catId);
              card.classList.toggle('is-selected', isSelected);
              card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });

            if (categoryGridWrapper) categoryGridWrapper.classList.remove('is-hidden');
            if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
            if (breadcrumb)          breadcrumb.classList.remove('is-visible');

            renderFaqs();
            faqBody.scrollIntoView({ behavior: 'smooth' });
          });
        });

        const faqButtons = noResultsEl.querySelectorAll('.faq-no-results-faq');
        faqButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const faqId = btn.getAttribute('data-suggest-faq-id');
            if (!faqId) return;

            const faq = faqs.find(function (f) {
              return String(f.id) === String(faqId);
            });

            let targetCatId = null;
            if (faq && faq.category_ids && faq.category_ids.length) {
              targetCatId = String(faq.category_ids[0]);
            }

            deepLinkFaq          = null;
            deepLinkCategoryMode = false;
            searchInput.value    = '';
            currentCategoryId    = targetCatId;
            activeSearchCategoryId = null;

            categoryCards.forEach(function (card) {
              const id = card.getAttribute('data-category-id');
              const isSelected = targetCatId && String(id) === targetCatId;
              card.classList.toggle('is-selected', isSelected);
              card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });

            if (categoryGridWrapper) categoryGridWrapper.classList.remove('is-hidden');
            if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
            if (breadcrumb)          breadcrumb.classList.remove('is-visible');

            renderFaqs();

            const targetBtn = document.getElementById('faq-q-' + faqId);
            if (targetBtn) {
              targetBtn.focus({ preventScroll: false });
              targetBtn.click();
            }
          });
        });
      }

      function escapeHtml(s) {
        return String(s || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

            function renderAssemblyBlock(faq) {
        const assemblyList = Array.isArray(faq.assembly_lists) ? faq.assembly_lists : [];
        const amazonList = Array.isArray(faq.amazon_lists) ? faq.amazon_lists : [];

        const currentList = selectedAssemblySource === 'amazon' ? amazonList : assemblyList;

        if (!assemblyList.length && !amazonList.length) return '';

        const itemsHtml = currentList
          .filter(function (i) { return i && (i.title || i.link); })
          .map(function (i) {
            const title = escapeHtml(i.title || 'Assembly Guide (PDF)');
            const linkRaw = (i.link || '').trim();

            if (!linkRaw) {
              return `<li class="faq-assembly-item"><span class="faq-assembly-text">${title}</span></li>`;
            }

            const href = escapeHtml(
              linkRaw + (linkRaw.includes('?') ? '&download=1' : '?download=1')
            );

            return `
              <li class="faq-assembly-item">
                <a
                  class="faq-assembly-link"
                  href="${href}"
                  download
                  aria-label="${title} (PDF)"
                >
                  <span class="faq-assembly-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="16" height="16">
                      <path d="M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 12h10v2H7v-2zm0 4h10v2H7v-2zm0-8h6v2H7V8z"></path>
                    </svg>
                  </span>
                  <span class="faq-assembly-title">${title}</span>
                </a>
              </li>
            `;
          })
          .join('');

        if (!itemsHtml) return '';

        return `
          <div class="faq-assembly" aria-label="Assembly instructions">
            <h4 class="faq-assembly-title">
              ${selectedAssemblySource === 'amazon' ? 'Amazon Instructions' : 'Assembly Instructions'}
            </h4>
            <ul class="faq-assembly-list">
              ${itemsHtml}
            </ul>
          </div>
        `;
      }

      // Filter pills
      if (filterPills && filterPills.length) {
        filterPills.forEach(function (pill) {
          pill.addEventListener('click', function () {
            const filterId = pill.getAttribute('data-filter');
            setFilterPillState(filterId);
            renderFaqs();
          });
        });
      }

      // Category cards (manual click)
      categoryCards.forEach(function (card) {
        card.addEventListener('click', function () {
          showAllFaqs          = false;
          deepLinkFaq          = null;
          deepLinkCategoryMode = false;

          const id    = card.getAttribute('data-category-id');
          const gLink = card.getAttribute('data-category-link') || '';

          currentCategoryId = id;
          expandedAll       = false;

          categoryCards.forEach(function (c) {
            const isSelected = c === card;
            c.classList.toggle('is-selected', isSelected);
            c.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });

          searchInput.value = '';

          if (gLink) setCategoryUrlParam(gLink);
          else       clearCategoryUrlParam();

          if (categoryGridWrapper) categoryGridWrapper.classList.remove('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.remove('is-visible');

          renderFaqs();
        });
      });

      // Search
      searchInput.addEventListener('input', function () {
        deepLinkFaq          = null;
        deepLinkCategoryMode = false;
        showAllFaqs          = false;

        clearCategoryUrlParam();
        clearFaqUrlParam();

        const value    = searchInput.value.trim();
        const hasQuery = value.length > 0;

        if (hasQuery) {
          currentCategoryId = null;
          categoryCards.forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });

          if (categoryGridWrapper) categoryGridWrapper.classList.add('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.add('is-visible');
          if (breadcrumb)          breadcrumb.classList.add('is-visible');

          setFilterPillState('all');
        } else {
          activeSearchCategoryId = null;

          if (categoryGridWrapper) categoryGridWrapper.classList.remove('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.remove('is-visible');

          setFilterPillState('all');
        }

        renderFaqs();

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'faqSearch',
            searchTerm: searchInput.value
          });
        }
      });

      // Show more / less
      expandToggle.addEventListener('click', function () {
        expandedAll = !expandedAll;
        renderFaqs();
      });

      // Back button
      if (backButton) {
        backButton.addEventListener('click', function () {
          deepLinkFaq          = null;
          deepLinkCategoryMode = false;
          showAllFaqs          = false;
          currentCategoryId    = null;
          activeSearchCategoryId = null;
          expandedAll          = false;
          searchInput.value    = '';

          clearCategoryUrlParam();
          clearFaqUrlParam();

          if (categoryGridWrapper) categoryGridWrapper.classList.remove('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.remove('is-visible');

          setFilterPillState('all');
          renderFaqs();

          const section = document.getElementById('faq-help-center');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      // See-all button
      if (seeAllBtn) {
        seeAllBtn.addEventListener('click', function () {
          showAllFaqs          = true;
          deepLinkFaq          = null;
          deepLinkCategoryMode = false;
          currentCategoryId    = null;
          activeSearchCategoryId = null;
          expandedAll          = false;
          searchInput.value    = '';

          categoryCards.forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });

          if (categoryGridWrapper) categoryGridWrapper.classList.add('is-hidden');
          if (filterPillsContainer) filterPillsContainer.classList.remove('is-visible');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.remove('is-visible');

          faqBody.classList.remove('is-empty');
          renderFaqs();
          faqBody.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      /* ------------------ deep-link init ------------------ */

      function initFromUrl() {
        const params   = new URLSearchParams(window.location.search);
        const faqKey   = params.get('faq') || params.get('a');
        const catKeyRaw = params.get('g');

        // 1) FAQ deep-link (?a= / ?faq=)
        if (faqKey) {
          let targetFaq = faqs.find(function (f) {
            return f.search_link && String(f.search_link) === String(faqKey);
          });

          // Legacy fallback
          if (!targetFaq && params.get('a')) {
            try {
              let decoded = decodeURIComponent(params.get('a'));
              if (decoded.indexOf('%') !== -1) {
                decoded = decodeURIComponent(decoded);
              }
              const parts   = decoded.split('---id--');
              const cleaned = parts[0].replace(/-/g, ' ').trim().toLowerCase();
              targetFaq = faqs.find(function (f) {
                return (f.question || '').toLowerCase().indexOf(cleaned) !== -1;
              });
            } catch (e) {
              console.warn('FAQ deep-link decode error', e);
            }
          }

          if (!targetFaq) {
            renderFaqs();
            return;
          }

          deepLinkFaq          = targetFaq;
          deepLinkCategoryMode = false;

          if (targetFaq.category_ids && targetFaq.category_ids.length) {
            currentCategoryId = String(targetFaq.category_ids[0]);
          } else {
            currentCategoryId = null;
          }

          // Optional: show question in search bar (not used for filtering)
          searchInput.value = targetFaq.question || '';

          if (categoryGridWrapper) categoryGridWrapper.classList.add('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.add('is-visible');

          renderFaqs();

          setTimeout(function () {
            const btn = document.getElementById('faq-q-' + targetFaq.id);
            if (!btn) return;
            btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
            btn.focus();
          }, 0);

          return;
        }

        // 2) Category deep-link (?g=)
        if (catKeyRaw) {
          let catKey = catKeyRaw;
          try { catKey = decodeURIComponent(catKeyRaw); } catch (e) {}

          const normKey = normalizeCategoryKey(catKey);

          const targetCat = categories.find(function (c) {
            const link   = normalizeCategoryKey(c.search_link || '');
            const name   = normalizeCategoryKey(c.name || '');
            const handle = normalizeCategoryKey(c.handle || '');
            return (link === normKey || name === normKey || handle === normKey);
          });

          if (!targetCat) {
            renderFaqs();
            return;
          }

          deepLinkFaq          = null;
          deepLinkCategoryMode = true;
          currentCategoryId    = String(targetCat.id);
          activeSearchCategoryId = null;
          searchInput.value    = '';

          if (categoryGridWrapper) categoryGridWrapper.classList.add('is-hidden');
          if (resultsSidebar)      resultsSidebar.classList.remove('is-visible');
          if (breadcrumb)          breadcrumb.classList.add('is-visible');

          renderFaqs();

          setTimeout(function () {
            const titleEls = accordionList.querySelectorAll('.faq-category-title');
            if (titleEls.length) {
              titleEls[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 0);

          return;
        }

        // 3) No deep-link → normal state
        renderFaqs();
      }

      initFromUrl();
    })();
